import React from "react";
import { GiExplodingPlanet } from "react-icons/gi";
import { Link } from "react-router-dom";
import { HiUserGroup } from "react-icons/hi2";
import { Helmet } from "react-helmet";
const Gridshow = () => {
  return (
    <div className="w-full max-w-[1400px] px-4 p-4 mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
      <Helmet>
        <title>Consulting and IT Services | Nexify Infosystems</title>
        <meta
          name="description"
          content="Explore Nexify's consulting and IT services. Discover how we provide technology-driven solutions and staff augmentation to meet client needs."
        />
        <meta
          name="keywords"
          content="Consulting, IT Services, Technology Solutions, Staff Augmentation, Nexify"
        />
      </Helmet>
      <div className="bg-gradient-to-r from-gray-200 to-[#c2e1f8] p-6 shadow-md flex flex-col  ">
        <div className="flex flex-col items-center">
          <HiUserGroup size={60} color="#005eb8" />
          <p className="text-md text-[#005eb8] font-[500]">SMALL TACTICS</p>
        </div>
        <p className="mb-4 text-black text-xl font-[500] text-center">
          Consulting
        </p>
        <p className="mb-4 text-[13px] text-gray-500 ">
          Nexify offers technical temporary staffing, right-to-hire, and staff
          augmentation services to meet our clients' technology talent needs.
        </p>
        <Link
          to="/consulting"
          className="text-[#0e55a8] text-left text-[11px] font-semibold cursor-pointer"
        >
          Read More &gt;&gt;
        </Link>
      </div>

      <div className="bg-gradient-to-l from-white to-[#d3e4f1] p-6 shadow-md flex flex-col">
        <div className="flex flex-col items-center">
          <GiExplodingPlanet size={60} color="#005eb8" />
          <p className="text-md text-[#005eb8] font-[500] mt-2">
            PLAN, THEN DO
          </p>
        </div>
        <p className="mb-4 text-black text-xl font-[500] text-center">
          IT Services
        </p>
        <p className="mb-4 text-[13px] text-gray-500">
          Nexify provides technology-driven solutions that add value across
          industries. With a focus on digital engineering and a deep
          understanding of our clients' needs, we deliver tailored end-to-end
          services that optimize operations and foster innovation.
        </p>
        <Link
          to="/service"
          className="text-[#0e55a8] text-[11px] font-semibold cursor-pointer"
        >
          Read More &gt;&gt;
        </Link>
      </div>
    </div>
  );
};

export default Gridshow;
